import type { ChatMessage } from '../../contexts/ChatContext';

/** One line the operator can see for an agent verb and the model read it used. */
export function chatVisibleModelRead(metadata: ChatMessage['metadata'] | undefined): string | null {
  if (!metadata) return null;
  const history = metadata.commandHistory;
  const snapshot = metadata.model_snapshot;
  if (!history && snapshot == null) return null;
  const command = history?.command ? `/${history.command}` : 'model read';
  const source = history?.dataSource ? ` from ${history.dataSource}` : '';
  const outcome = history?.success === false ? ' failed' : history ? ' completed' : '';
  const snapshotNote = snapshot != null ? ' · model snapshot attached' : '';
  return `Model read ${command}${source}${outcome}${snapshotNote}`;
}
